import { Component, inject, Input } from '@angular/core'
import {
	FormValidationComponent,
	ValidationMessages,
} from '@ui/Components/Form/FormValidation.Component'
import HttpError, { FormErrors } from '@ui/HttpError'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import {
	InputValue,
	TextInputComponent,
} from '@ui/Components/Form/TextInput/TextInput.Component'
import { PermissionsService } from '@client/Services/PermissionsService'
import { NgStyle } from '@angular/common'
import { FlatButtonComponent } from '@ui/Components/Form/Button/FlatButton.Component'

@Component({
	selector: 'two-factor-challenge',
	templateUrl: './TwoFactorChallenge.Component.html',
	styleUrls: ['../../Auth.css'],
	imports: [
		FormsModule,
		ReactiveFormsModule,
		TextInputComponent,
		NgStyle,
		FlatButtonComponent,
	],
})
export class TwoFactorChallengeComponent extends FormValidationComponent {
	@Input() private readonly loginSuccessful: () => void | Promise<void>

	public formErrors: FormErrors = {}

	public validationMessages: ValidationMessages = {}

	public useRecoveryCode = false

	public error: string | FormErrors = ''

	private readonly permissionService: PermissionsService

	constructor() {
		super()
		this.permissionService = inject(PermissionsService)
	}

	public confirmChallenge = async (
		code: InputValue,
		recoveryCode: InputValue,
	): Promise<void> => {
		try {
			await this.permissionService.twoFactorLogin(
				code ? (code as string) : undefined,
				recoveryCode ? (recoveryCode as string) : undefined,
			)

			this.loginSuccessful()
		} catch (error) {
			if (error instanceof HttpError) {
				if (error.isUnprocessableEntity()) {
					const errors = error.handleFormErrors(this.formErrors, '')

					this.error = this.useRecoveryCode ? errors.recovery_code : errors.code

					this.markInvalidFields()

					return
				}
			}
		}
	}

	public switchToRecovery = () => {
		this.useRecoveryCode = true
	}

	public switchToCode = () => {
		this.useRecoveryCode = false
	}

	protected buildForm() {
		this.form = this.formBuilder.group({
			code: ['', []],
			recovery_code: ['', []],
		})
	}
}
